import styled from '@emotion/styled'
import React, { type FunctionComponent } from 'react'
import { OverrideType } from 'domains/products/api'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

interface AttributeOverridesTableOverrideTypeCellProps {
  overrideType: OverrideType
}

const StyledContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

export const AttributeOverridesTableOverrideTypeCell: FunctionComponent<
  AttributeOverridesTableOverrideTypeCellProps
> = ({ overrideType }) => {
  const messages = useDomainMessages({
    [OverrideType.OverrideTypeExclude]: 'productsDomain.attributeOverride.overrideType.exclude',
    [OverrideType.OverrideTypeReplace]: 'productsDomain.attributeOverride.overrideType.replace',
  })

  return <StyledContainer>{messages[overrideType]}</StyledContainer>
}
